var map = {
	"./assets/clickable/twitter.svg": "2342733510c07bf603d0",
	"./assets/disabled/twitter.svg": "de6905ad9fc86102547d",
	"./assets/original/twitter.svg": "00b8b1dee1f94450e797"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5df76b566cd24fa38c98";